import React from "react";
import DocumentDetail from "../Components/DocumentCrafting/Detail/DocumentDetail";

const DocumentCraftingDetailPage: React.FC = () => <DocumentDetail />;

export default DocumentCraftingDetailPage;
